import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {InsolesProviderModelGabaritModel} from "../../../../provider/model/api/entity/insolesProviderModelGabarit.model";

export class InsoleDataSummaryModel implements SummaryModel {
    permissions: PermissionsModel;
    id: number;
    side: LovValueSummary;
    shoeSize: LovValueSummary;
    providerInsoleModelGabarit: InsolesProviderModelGabaritModel;
    gabarit: LovValueSummary;
    thermo: LovValueSummary;
    border: LovValueSummary;
    borderExternalLength: LovValueSummary;
    bevel: LovValueSummary;
    medioOverCorrection: number;
    thickness: number;
    medioSmooth: LovValueSummary;
}
